import React, { useEffect, useState } from 'react';
import { ADDRESSES, CONTACT, BROCHURE_PDF, whatsappHref } from '../data/siteContent';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message. We will get back to you soon.');
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="relative bg-brand-950 overflow-hidden">
        <div className="absolute inset-0 industrial-grid opacity-20" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 text-center text-white">
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight mb-4">Contact</h1>
          <p className="text-lg text-brand-100 max-w-2xl mx-auto">
            Flooring enquiries, site visits, and technical coordination for SV Bond and compatible systems.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-10 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-white rounded-large shadow-custom border border-neutral-200 p-8">
              <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center text-brand-900 mb-4">
                <i className="fas fa-map-marker-alt text-xl" />
              </div>
              <h3 className="font-heading text-lg font-bold text-neutral-900 mb-2">Pune (office)</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">{ADDRESSES.puneOffice}</p>
            </div>

            <div className="bg-white rounded-large shadow-custom border border-neutral-200 p-8">
              <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center text-brand-900 mb-4">
                <i className="fas fa-map-marker-alt text-xl" />
              </div>
              <h3 className="font-heading text-lg font-bold text-neutral-900 mb-2">Goa (regional office)</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">{ADDRESSES.goaOffice}</p>
              <p className="text-sm text-neutral-500 mt-2">{CONTACT.goaPhone}</p>
            </div>

            <div className="bg-white rounded-large shadow-custom border border-neutral-200 p-8">
              <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center text-brand-900 mb-4">
                <i className="fas fa-tools text-xl" />
              </div>
              <h3 className="font-heading text-lg font-bold text-neutral-900 mb-2">Workshop</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">{ADDRESSES.workshop}</p>
            </div>

            <div className="bg-white rounded-large shadow-custom border border-neutral-200 p-8">
              <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center text-brand-900 mb-4">
                <i className="fas fa-phone-alt text-xl" />
              </div>
              <h3 className="font-heading text-lg font-bold text-neutral-900 mb-2">Phone</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                {CONTACT.phones.map((p) => (
                  <span key={p} className="block">
                    {p}
                  </span>
                ))}
              </p>
            </div>

            <div className="bg-brand-900 rounded-large shadow-custom p-8 text-white">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mb-4">
                <i className="fab fa-whatsapp text-2xl" />
              </div>
              <h3 className="font-heading text-lg font-bold mb-2">WhatsApp</h3>
              <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="text-brand-200 hover:text-white font-medium">
                {CONTACT.whatsappDisplay}
              </a>
            </div>

            <div className="bg-white rounded-large shadow-custom border border-neutral-200 p-8">
              <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center text-brand-900 mb-4">
                <i className="fas fa-file-pdf text-xl" />
              </div>
              <h3 className="font-heading text-lg font-bold text-neutral-900 mb-2">Brochure</h3>
              <p className="text-neutral-600 text-sm leading-relaxed mb-3">
                Company profile, product range, and technical overview.
              </p>
              <a
                href={BROCHURE_PDF}
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-800 hover:underline font-semibold text-sm"
              >
                Download brochure (PDF)
              </a>
            </div>

            <div className="bg-white rounded-large shadow-custom border border-neutral-200 p-8">
              <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center text-brand-900 mb-4">
                <i className="fas fa-envelope text-xl" />
              </div>
              <h3 className="font-heading text-lg font-bold text-neutral-900 mb-2">Email</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                <a href={`mailto:${CONTACT.emailPrimary}`} className="text-brand-800 hover:underline">
                  {CONTACT.emailPrimary}
                </a>
                <br />
                <a href={`mailto:${CONTACT.emailLegacy}`} className="text-neutral-500 hover:underline text-sm">
                  {CONTACT.emailLegacy}
                </a>
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="bg-white rounded-large shadow-custom border border-neutral-200 p-8 sm:p-10 h-full">
              <h2 className="font-heading text-2xl font-bold text-neutral-900 mb-6">Send a message</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-neutral-700 mb-2" htmlFor="contact-name">
                      Name
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-small border border-neutral-200 focus:ring-2 focus:ring-brand-900/20 focus:border-brand-900 outline-none bg-neutral-50 focus:bg-white"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-neutral-700 mb-2" htmlFor="contact-email">
                      Email
                    </label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-small border border-neutral-200 focus:ring-2 focus:ring-brand-900/20 focus:border-brand-900 outline-none bg-neutral-50 focus:bg-white"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-neutral-700 mb-2" htmlFor="contact-subject">
                    Subject
                  </label>
                  <input
                    id="contact-subject"
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-small border border-neutral-200 focus:ring-2 focus:ring-brand-900/20 focus:border-brand-900 outline-none bg-neutral-50 focus:bg-white"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-neutral-700 mb-2" htmlFor="contact-message">
                    Message
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    className="w-full px-4 py-3 rounded-small border border-neutral-200 focus:ring-2 focus:ring-brand-900/20 focus:border-brand-900 outline-none bg-neutral-50 focus:bg-white resize-none"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full md:w-auto bg-brand-900 hover:bg-brand-800 text-white font-bold py-3.5 px-10 rounded-small shadow-custom transition-colors"
                >
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
